module.exports = __webpack_public_path__ + "img/ic-ic-new-blog.b23ce056.svg";